

const genericField = {
        metaList:[
            {
                label:'Ticket No',
                link:true,
                routePath:'ticketsystems'/// routePath is required at start of object
            },
            {
                label:'description',
                link:false,
                routePath:''
            }
    ],

    columns: ['ticket_no', 'description'],
};

export default genericField;
